"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketEventType = void 0;
var SocketEventType;
(function (SocketEventType) {
    SocketEventType["NewNote"] = "newNote";
})(SocketEventType || (exports.SocketEventType = SocketEventType = {}));
